import { Component } from "react"
import PropTypes from "prop-types"

import Meta from "./meta"
import verified from "images/shared/icon-verified_service.svg"

export default class WebAppletCard extends Component {
  render() {
    const authorClassName = this.props.applet.by_service_owner ? "author official" : "author"
    const permissions = this.props.applet.permissions || []
    const mainPermissions = permissions.length === 3 ? permissions : permissions.slice(0, 2)
    const remainingPermsNumber = permissions.length - mainPermissions.length

    return (
      <>
        <div className="content">
          <div className="meta-header publisher">
            {permissions.length > 0 && (
              <div className="works-with">
                <ul className="permissions">
                  {mainPermissions.map(p => (
                    <li key={`permission-${p.id}`}>
                      <img src={p.icon_url} width="26" height="26" alt={p.service_name} title={p.service_name} />
                    </li>
                  ))}
                  {remainingPermsNumber > 0 && <li>{remainingPermsNumber}+</li>}
                </ul>
              </div>
            )}
          </div>

          <span className="title">{this.props.applet.name}</span>

          <p className={authorClassName}>
            by
            <span>
              <b>{this.props.applet.author}</b>
              {this.props.applet.by_service_owner && (
                <span
                  className="verified"
                  title="Verified"
                  dangerouslySetInnerHTML={{ __html: verified }}
                />
              )}
            </span>
          </p>
        </div>
        <Meta applet={this.props.applet} />
      </>
    )
  }
}

WebAppletCard.propTypes = {
  applet: PropTypes.object.isRequired,
  uniquePermissions: PropTypes.array,
}
